import { CMSWrapper } from "@lib/wrappers/cmsWrapper";
import type { IMicrocopySet } from "@contentful-api/types/contentful";
import type { Order } from "./types";

export const addPromotionNamesToOrders = async (
    fetchedOrders: Order[],
    locale: string
): Promise<Order[] | null> => {
    if (!fetchedOrders || fetchedOrders.length === 0) {
        return null;
    }
    return await Promise.all(
        fetchedOrders.map(async (order) => {
            const promotionNames = await getPromotionNames(order, locale);
            if (promotionNames) {
                order.promotionName = promotionNames;
            }
            return order;
        })
    );
};

const getPromotionNameMicroCopyset = async (locale) => {
    const offers = await CMSWrapper.getInstance().getEntries<IMicrocopySet>({
        content_type: "microcopySet",
        "fields.key[in]": "offers",
        select: "fields",
        include: 10,
        limit: 1,
        locale: locale,
    });
    const promotionNameDictionary = Array.isArray(offers?.includes?.Entry)
        ? offers?.includes?.Entry.reduce((acc, item) => {
              acc[item.fields.key] = item.fields.value;
              return acc;
          }, {})
        : {};
    return promotionNameDictionary || {};
};

const getPromotionNames = async (order, locale): Promise<string[] | null> => {
    try {
        const promotionNamesFromContentful = await getPromotionNameMicroCopyset(locale);
        let promotionNames = [];
        let promotionIds = [];
        order?.lines?.forEach((line) => {
            if (line?.promotionName) {
                promotionNames = promotionNames.concat(line.promotionName.split(";"));
            }
            if (line?.promotionId) {
                promotionIds = promotionIds.concat(line.promotionId.split(";"));
            }
        });
        const promotionIdDescriptions = promotionIds.map((id) => {
            const promotionIdKey = `${id}.description`;
            return promotionNamesFromContentful[promotionIdKey] || id;
        });
        return Array.from(new Set(promotionNames.concat(promotionIdDescriptions)));
    } catch (error) {
        return null;
    }
};
